<div class="filter-tree-field" data-cy="iot-platform-ui-filter-tree-field">
  <iot-platform-ui-form-group [fields]="fields()" [group]="form" />

  @if (requiresValue()) {
    @if (showTree()) {
      <div class="tree-container">
        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree">
          <mat-tree-node
            *matTreeNodeDef="let node"
            [matTreeNodePaddingIndent]="10"
            matTreeNodePadding
            [matTooltip]="
              !isNodeSelected(node) && isOptionDisabled(node) && isMaxFiltersReached()
                ? ('FILTER_ENGINE.TOO_MANY_ITEMS' | translate: { count: getDescendantsCount(node), max: maxFilters() })
                : ''
            "
          >
            <button aria-hidden="true" disabled mat-icon-button>
              <mat-icon class="mat-icon-rtl-mirror"></mat-icon>
            </button>
            <mat-checkbox
              [checked]="checklistSelection.isSelected(node)"
              [disabled]="isOptionDisabled(node)"
              (change)="leafItemSelectionToggle(node)"
              [matTooltip]="getNodeLabel(node) | translate"
            >
              {{ getNodeLabel(node) | translate }}
            </mat-checkbox>
          </mat-tree-node>

          <!-- Expandable node template -->
          <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            [matTreeNodePaddingIndent]="10"
            matTreeNodePadding
            [matTooltip]="
              !isNodeSelected(node) && isOptionDisabled(node) && isMaxFiltersReached()
                ? ('FILTER_ENGINE.TOO_MANY_ITEMS' | translate: { count: getDescendantsCount(node), max: maxFilters() })
                : ''
            "
          >
            @if (node.expandable) {
              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + getNodeLabel(node)">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
              </button>
            }
            <mat-checkbox
              [checked]="selectOnlyLeafNodes() ? descendantsAllSelected(node) : checklistSelection.isSelected(node)"
              [indeterminate]="selectDistinctNodes() ? false : descendantsPartiallySelected(node)"
              [disabled]="isOptionDisabled(node)"
              (change)="itemSelectionToggle(node)"
              (mouseenter)="isOptionDisabled(node)"
              [matTooltip]="getNodeLabel(node) | translate"
            >
              {{ getNodeLabel(node) | translate }}
            </mat-checkbox>
          </mat-tree-node>
        </mat-tree>
      </div>
    } @else {
      <div
        data-cy="iot-platform-ui-filter-tree-field-no-rows"
        class="tree-container filter-tree-field--no-rows"
        fxFlex
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        {{ 'AG_GRID.noRowsToShow' | translate }}
      </div>
    }
  }
</div>
